import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

const STATUS_OPTIONS: ReportOption[] = [
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'user_name', label: 'Employee' },
  { key: 'date', label: 'Date' },
  { key: 'hours', label: 'Hours', align: 'right' },
  { key: 'status', label: 'Status' },
  { key: 'decided_by', label: 'Decided By' },
];

export function OvertimeReportPage() {
  return (
    <ReportView
      title="Overtime Report"
      description="Overtime requests submitted, with hours and decision status."
      endpoint="/reports/hr/overtime"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
    />
  );
}
